import * as React from "react";
import { useSelector, useDispatch } from "react-redux";
import "./Base.css";
import { Container, Row, Col } from "reactstrap";
const VerifyCheckUnderwriting = (props) => {
    const selectVerifyCheckState = (state) => state.verifyCheck;
    const verifyCheckState = useSelector(selectVerifyCheckState);
    const dispatch = useDispatch();
    const verifyCheck = useSelector((state) => state.verifyCheck);
    const [isConfirmed, setIsConfirmed] = React.useState(false);
    const processStateAction = (x) => ({ type: 'GOTO_PROCESS_STATE', processState: x });
    const submitData = (e) => {
        dispatch(processStateAction(e.currentTarget.value));
    };
    return React.createElement("div", null,
        React.createElement("h3", null,
            "This AutoCheck has been verified as a valid AutoCheck ",
            React.createElement("br", null),
            "issued by ",
            verifyCheck ? verifyCheck.creditUnion.name : ""),
        React.createElement(Container, null,
            React.createElement(Row, null,
                React.createElement(Col, { xs: "9" },
                    React.createElement("div", null, "This check has been issued to: "),
                    React.createElement("div", null,
                        React.createElement("strong", null, "Borrower 1: "),
                        verifyCheck ? verifyCheck.siteDraft.borrower1NameFirst : "",
                        "\u00A0",
                        verifyCheck ? verifyCheck.siteDraft.borrower1NameLast : "",
                        " "),
                    React.createElement("div", null,
                        React.createElement("strong", null, "Borrower 2: "),
                        verifyCheck ? verifyCheck.siteDraft.borrower2NameFirst : "",
                        "\u00A0",
                        verifyCheck ? verifyCheck.siteDraft.borrower2NameLast : "",
                        " "),
                    React.createElement("div", null,
                        React.createElement("strong", null, "By: "),
                        verifyCheck ? verifyCheck.creditUnion.name : ""),
                    React.createElement("div", null, "In order to deposit this check please confirm that the follow criteria has been met:"),
                    React.createElement("div", null,
                        React.createElement("ul", null,
                            React.createElement("li", null, "The LTV meets the limits as stated on the front of the auto check"),
                            React.createElement("li", null,
                                "The total amount of check is less than $",
                                verifyCheck ? verifyCheck.siteDraft.loanApprovedLimit.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') : "None"),
                            React.createElement("li", null,
                                "The mileage is less than ",
                                verifyCheck ? verifyCheck.siteDraft.mileageLimitation : "None",
                                " miles"),
                            React.createElement("li", null,
                                "The vehicle's model year is ",
                                verifyCheck ? verifyCheck.siteDraft.yearLimitationYear : "None",
                                " or newer"),
                            React.createElement("li", null, "The name(s) on the title are the same as the name(s) printed on the AutoCheck"),
                            React.createElement("li", null, "This is not a salvaged, rebuilt, or flood damaged vehicle"),
                            React.createElement("li", null, "Dealer and Borrower have signed the AutoCheck"),
                            React.createElement("li", null,
                                "Special Instructions: ",
                                verifyCheck ? verifyCheck.siteDraft.specialInstructions : "0")),
                        React.createElement("div", null,
                            React.createElement("input", { type: "checkbox", id: "chkAcknowledge", name: "chkAcknowledge", value: "chkAcknowledge", onClick: (e) => { setIsConfirmed(e.currentTarget.checked); } }),
                            React.createElement("label", { htmlFor: "chkAcknowledge" }, "\u00A0By checking and submitting I acknowledge all criteria has been met."))),
                    React.createElement("div", { className: "button_container" },
                        React.createElement("button", { className: "btn btn-primary", disabled: !isConfirmed, name: "btnContinue", value: "adoptStart", onClick: submitData }, "Continue")),
                    React.createElement("div", null)),
                React.createElement(Col, { xs: "3" },
                    React.createElement("div", null,
                        "Credit Union Contact Info:",
                        React.createElement("br", null),
                        verifyCheck ? verifyCheck.siteDraft.loanOfficerName : "",
                        React.createElement("br", null),
                        verifyCheck ? verifyCheck.siteDraft.loanOfficerEmail : "",
                        React.createElement("br", null),
                        verifyCheck ? verifyCheck.siteDraft.loanOfficerPhone : "",
                        React.createElement("br", null),
                        verifyCheck ? verifyCheck.siteDraft.loanOfficerFax : "",
                        React.createElement("br", null))))));
};
//VerifyCheckVerificationSuccess.defaultProps = VerifyCheckStore.actionCreators;
export default VerifyCheckUnderwriting;
//# sourceMappingURL=VerifyCheckUnderwriting.js.map